class ImagePreloader extends HTMLElement {
  connectedCallback() {
    this.tryPreload() || this.setupObserver();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  tryPreload() {
    const img = this.querySelector('img');
    const src = img?.src || img?.getAttribute('src');

    if (src && !document.querySelector(`link[rel="preload"][href="${src}"]`)) {
      queueMicrotask(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = src;
        link.fetchPriority = 'high';
        document.head.appendChild(link);
      });
      return true;
    }
    return false;
  }

  setupObserver() {
    this.observer = new MutationObserver(() => {
      if (this.tryPreload()) {
        this.observer.disconnect();
      }
    });
    this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }
}

customElements.define('image-preloader', ImagePreloader);
